import useNav from '@core/layouts/composable/useNav'
import { ref, watch } from 'vue'
import { useRouter } from 'vue-router/composables'

export default function useHorizontalNavMenuHeaderGroup(item) {
  const { isNavLinkActive, navLinkProps } = useNav()
  const { app } = useRouter()

  // ------------------------------------------------
  // isActive
  // ------------------------------------------------
  const isActive = ref(false)

  const updateIsActive = () => {
    isActive.value = isNavLinkActive(item)
  }
  watch(() => app._route.name, updateIsActive, { immediate: true })

  // ------------------------------------------------
  // linkProps
  // ------------------------------------------------
  const linkProps = navLinkProps.value(item)

  return {
    isActive,
    updateIsActive,
    linkProps,
  }
}
